import { baseUrl, baseUrlName } from "./baseUrl";

// eslint-disable-next-line import/prefer-default-export
export const getBalanceRoute = (agreementId) => {
  const queryString = `?agreementId=${agreementId}`;
  switch (baseUrlName) {
    case "numericIds":
    case "default":
    default:
      const pathnameNumericIds = [`${baseUrl}`, "balance-api", "balance", "get-balance"].join("/");
      return [pathnameNumericIds, queryString].join("");
  }
};
